import Layout from 'Components/Shared/Layout';

const App = () => {
  return (
    <Layout/>
  );
}

export default App;
